import * as React from 'react';
import { createContext, useContext, useState } from 'react';

import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';
import { CoachStateProvider } from 'bundles/unified-common/providers/CoachStateProvider';
import useSpecializationContextConfig from 'bundles/unified-description-page-common/components/coach/useSpecializationContextConfig';
import { useIsS12nDataLoading } from 'bundles/unified-description-page-common/contexts/consumer/ConsumerBffSpecializationContext';

export type TwoPanelConversationalDiscoveryExperimentContextType = {
  twoPanelConversationalDiscoveryEnabled: boolean;
  chatOnLeft: boolean;
  chatOnRight: boolean;
};

export const TwoPanelConversationalDiscoveryExperimentContext =
  createContext<TwoPanelConversationalDiscoveryExperimentContextType>({
    twoPanelConversationalDiscoveryEnabled: false,
    chatOnLeft: false,
    chatOnRight: false,
  });

const COACH_MODE_TWO_PANEL_CONVERSATIONAL_DISCOVERY_ID = 'XDP_CAREER_FIT_ASSISTANT_V3';
const COACH_MODE_TWO_PANEL_CONVERSATIONAL_DISCOVERY_ACTION_ID = 'WELCOME_MESSAGE';

function TwoPanelConversationalDiscoveryExperimentProvider({ children }: React.PropsWithChildren) {
  const isS12nDataLoading = useIsS12nDataLoading();
  const [value] = useState(() => {
    const variant = GrowthDiscoveryEpicClient.get('twoPanelConversationalDiscoveryOnXdp');
    return {
      twoPanelConversationalDiscoveryEnabled: variant !== 'control',
      chatOnLeft: variant === 'C',
      chatOnRight: variant === 'B',
    };
  });

  const contextConfig = useSpecializationContextConfig({
    coachModeId: COACH_MODE_TWO_PANEL_CONVERSATIONAL_DISCOVERY_ID,
    coachActionId: COACH_MODE_TWO_PANEL_CONVERSATIONAL_DISCOVERY_ACTION_ID,
  });
  return (
    <TwoPanelConversationalDiscoveryExperimentContext.Provider value={value}>
      {value.twoPanelConversationalDiscoveryEnabled ? (
        <CoachStateProvider coachOpen={true} contextConfig={contextConfig} isContextConfigLoading={isS12nDataLoading}>
          {children}
        </CoachStateProvider>
      ) : (
        children
      )}
    </TwoPanelConversationalDiscoveryExperimentContext.Provider>
  );
}

export const useTwoPanelConversationalDiscoveryExperiment = () => {
  return useContext(TwoPanelConversationalDiscoveryExperimentContext);
};

export default TwoPanelConversationalDiscoveryExperimentProvider;
